import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "device-mobile-vibration",
  "use": "device-mobile-vibration-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"icon icon-tabler icon-tabler-device-mobile-vibration\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" viewBox=\"0 0 24 24\" id=\"device-mobile-vibration\"><path d=\"M0 0h24v24H0z\" stroke=\"none\" /><g transform=\"rotate(20 12 12)\"><rect x=\"7\" y=\"4\" width=\"10\" height=\"16\" rx=\"1\" /><path d=\"M11 5h2M12 17v.01M3 8v8M21 8v8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol